import { useState } from 'react';
import { ScrollingColumn } from 'foundations-components/transitional/components/ScrollingColumn';
import FilterFamilyGroupSelectOptions from './FilterFamilyGroupSelectOptions';
import Search from './general/Search';
import PropertyTypeFilter from './general/PropertyTypeFilter';
import styled from 'foundations-theming/utils';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SearchGrowContainer = styled.div.withConfig({
  displayName: "FilterFamilyGroupSelect__SearchGrowContainer",
  componentId: "qh9dfj-0"
})(["flex-grow:1;"]);
const FilterFamilyGroupSelect = ({
  category,
  categoryLabel
}) => {
  const [searchString, setSearchString] = useState('');
  return /*#__PURE__*/_jsx(ScrollingColumn, {
    headerContent: /*#__PURE__*/_jsxs(Flex, {
      padding: "400",
      gap: "300",
      children: [/*#__PURE__*/_jsx(SearchGrowContainer, {
        children: /*#__PURE__*/_jsx(Search, {
          onSearchChange: evt => {
            setSearchString(evt.target.value);
          },
          searchPlaceholderAssetLabel: categoryLabel,
          value: searchString
        })
      }), /*#__PURE__*/_jsx(PropertyTypeFilter, {
        onChange: () => {},
        values: [],
        disabled: true,
        tooltipContent: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customerDataFiltersUI.dataExplorer.typeFilter.disabledReason",
          options: {
            assetLabel: categoryLabel
          }
        })
      })]
    }),
    children: /*#__PURE__*/_jsx(FilterFamilyGroupSelectOptions, {
      searchString: searchString,
      category: category
    }, category)
  });
};
export default FilterFamilyGroupSelect;